// This file includes a list of hardcoded accounts, used to determine
// which accounts receive the additional sites treatment

export const VIP_ACCOUNTS = {
	// account id: {
	// 	name: 'Account Name'
	// }
};
